import { TimelineModel } from '../../shared/models/timeline.model';

export enum ChangePasscodeStep {
    PHONE_VERIFICATION = 1,
    OLD_PASSCODE,
    PASSCODE_CHANGED,
}

export enum ChangePasscodeStep2FAOrderByOTP {
    PHONE_VERIFICATION = 1,
    LIVELINESS,
    OLD_PASSCODE,
    PASSCODE_CHANGED,
}

export enum ChangePasscodeStep2FAOrderByLiveliness {
    LIVELINESS = 1,
    PHONE_VERIFICATION,
    OLD_PASSCODE,
    PASSCODE_CHANGED,
}

export enum ChangePasswordStep {
    PHONE_VERIFICATION = 1,
    OLD_PASSWORD,
    PASSWORD_CHANGED,
}

export enum NewPasscodeStep {
    NEW_PASSCODE = 1,
    CONFIRM_PASSCODE,
    PASSCODE_CHANGED,
}

export const SettingsOtpTimeline: TimelineModel = {
    title: 'Verify Phone Number',
    description: 'We’ve just sent you a 6 digit code to your registered phone number. Check your messages and enter it here.',
    step: 1,
    state: 'active',
    previousTitle: 'Settings',
    data: { otp: '' },
};

export const ChangePasscodeTimes: TimelineModel[] = [
    SettingsOtpTimeline,
    {
        title: 'Change Passcode',
        description: 'To change your passcode, please confirm with your current passcode',
        step: 2,
        state: 'inactive',
        data: { oldPasscode: '', newPasscode: '' },
    },
];

export const ChangePasscodeTimes2FAOrderByOTP: TimelineModel[] = [
    {
        title: 'Verify Phone Number',
        description: 'We’ve just sent you a 6 digit code to your registered phone number. Check your messages and enter it here.',
        step: 1,
        state: 'inactive',
        mobileNote: 'STEP 1',
        previousTitle: 'Settings',
        data: { otp: '' },
    },
    {
        title: 'Verify ID Information',
        description: '',
        step: 2,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 2',
        data: { reference: '' },
    },
    {
        title: 'Change Passcode',
        description: 'To change your passcode, please confirm with your current passcode',
        step: 3,
        mobileNote: 'STEP 3',
        state: 'inactive',
        data: { oldPasscode: '', newPasscode: '' },
    },
];

export const ChangePasscodeTimes2FAOrderByLiveliness: TimelineModel[] = [
    {
        title: 'Verify ID Information',
        description: '',
        step: 1,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 1',
        data: { reference: '' },
    },
    {
        title: 'Verify Phone Number',
        description: 'We’ve just sent you a 6 digit code to your registered phone number. Check your messages and enter it here.',
        step: 2,
        state: 'inactive',
        mobileNote: 'STEP 2',
        previousTitle: 'Settings',
        data: { otp: '' },
    },
    {
        title: 'Change Passcode',
        description: 'To change your passcode, please confirm with your current passcode',
        step: 3,
        mobileNote: 'STEP 3',
        state: 'inactive',
        data: { oldPasscode: '', newPasscode: '' },
    },
];

export const ChangePasswordTimes: TimelineModel[] = [
    SettingsOtpTimeline,
    {
        title: 'New Password',
        description: 'To change your password, please confirm with your current password and enter your new password ',
        step: 2,
        state: 'inactive',
        mobileNote: 'STEP 2',
        data: { oldPassword: '', newPassword: '' },
    },
];

export const NewPasscodeTimes: TimelineModel[] = [
    {
        title: 'New Passcode',
        description: 'Enter a new 6 digit passcode',
        step: 1,
        state: 'active',
        data: { passcode: '' },
    },
    {
        title: 'Confirm Passcode',
        description: 'Re-enter your 6 digit passcode',
        step: 2,
        state: 'inactive',
        data: { confirmPasscode: '' },
    },
];

export interface PasscodeChangeInitiatorObj {
    ussdCode: string;
    otpMessage: string;
    verificationMethod: VerificationMethod;
    reference: string;
    provider: any;
    flowId: string;
}

export interface PasscodeOtpResponse {
    otpMessage: string;
    ussdCode: string;
}

export interface PasscodeOtpPayload {
    otp?: string;
    newPasscode: string;
    oldPasscode: string;
    reference?: string;
}

export interface NewPasscodePayload {
    passcode: string;
    deviceIdentifier: string;
}

export enum VerificationMethod {
    OTP = 'OTP',
    FACE_MATCH_CHECK = 'FACE_MATCH_CHECK',
}

export interface LoginOptionTypeResponse {
    loginType: any;
}

export enum VerificationMethod2Fa {
    OTP = 'OTP',
    FACE_MATCH_CHECK = 'FACE_MATCH',
    TWO_FACTOR_AUTHENTICATION = 'TWO_FACTOR_AUTHENTICATION',
}

export type FieldType = 'BOOLEAN' | 'TEXT' | 'NUMBER' | 'DROPDOWN';

export enum FieldTypes {
    BOOLEAN = 'BOOLEAN',
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    DROPDOWN = 'DROPDOWN'
}

export interface CustomTransactionField {
    id: number;
    fieldName: string;
    fieldType: FieldType;
    createdAt: string;
}

export interface ValidationMetaData {
    MAX_NUMBER?: number;
    MIN_NUMBER?: number;
    MAX_CHAR_LENGTH?: number;
    MIN_CHAR_LENGTH?: number;
}

export interface CreateCustomTransactionField {
    id?: string;
    fieldName: string;
    printOnReceipt: boolean
    fieldValues?: string[];
    fieldType: string
    transactionTypes: string[];
    validationMetaData?: ValidationMetaData;
}
